<template>
    <div>
        <hr>
        <div class="alert alert-info">
            Payment will be on your account
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12 text-right">
                <button class="btn btn-green" @click="submit" :disabled="processing">
                    <template v-if="!processing">
                        <i class="fa fa-lock"></i> Submit Order
                    </template>
                    <template v-else>
                        <i class="fa fa-refresh fa-spin"></i> Processing
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Checkout from '../../../Services/Checkout.js';
    import Order from '../../../Services/Order.js';

    export default {
        props: ['gatewayId'],
        data() {
            return {
                processing: false,
                checkout: Checkout,
                order: Order,
            }
        },
        methods: {
            submit() {
                this.processing = true;
                this.checkout.setType('On Account')
                .setGatewayId(this.gatewayId).process(
                    undefined,
                    undefined,
                    this.order.reference,
                    this.order.notes
                ).then(response => {
                    this.$emit('complete');
                }).catch(error => {
                    this.$emit('failed');
                    this.processing = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/Payments/AccountGateway.vue